import AppContainer from "../../components/AppContainer";
import Footer from "../../components/Footer/Footer";
import { getStore } from "../../services/backend/serverSideProps";

export async function getServerSideProps(context) {
  return getStore(context);
}

const PrivacyPolicy = (props) => {
  const { storeData, themeData } = props;
  const { privacy = "" } = storeData?.legalInfo || {};

  return (
    <AppContainer>
      <main>
        <h2 className="sidepage-title">Privacy Policy</h2>

        {/* content */}
        {privacy?.trim() != "" ? (
          <div className="sidepage-content" dangerouslySetInnerHTML={{ __html: privacy }} />
        ) : null}
      </main>

      <Footer theme={themeData} />
    </AppContainer>
  );
};

export default PrivacyPolicy;
